<template>
  <section class="awards-section-container">
    <div class="content-wrapper">
      <div class="image-wrapper" id="bigsee">
        <img src="../assets/awards/bigsee.png" alt="bigsee award">
      </div>
      <div class="image-wrapper">
        <img src="../assets/awards/design_award.png" alt="design award">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AwardsSection"
}
</script>

<style scoped>
.awards-section-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f2f2f2;
  height: 15vw;
  max-height: 300px;
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 10vw;
  margin-right: 10vw;
  width: 100%;
  height: 100%;
  max-width: 1600px;
}

.image-wrapper {
  height: 10vw;
  max-height: 200px;
  width: 50%;
}

#bigsee {
  padding: 1vw;
}

img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

@media only screen and (max-width: 700px) {
  .awards-section-container {
    display: none;
  }
}

</style>
